/* @flow */

import { callApiEndpoint } from './index';
import utils from './utils';

import type { Territory } from 'types';

const find = async (): Promise<Territory[]> => {
  const response = await callApiEndpoint('territori/findAll', { method: 'POST', body: {} });
  return response.map(utils.toTerritory);
};

export default {
  find,
};
